import styled from "styled-components";
import Link from "next/link";
import Banner from "@/components/UI/banner/banner";
import bannerImage from "../../../public/images/attorney-landing-banner.png";
import WhyChooseUs from "@/components/main/why-choose-us/whyChooseUs";
import attorneys from "../../../public/attorneys.json";
import AttorneyDropDown from "@/components/mobile-dropdown-menu/attorneyDropDown";

export default function Attorneys() {
  return (
    <>
      <Banner
        src={bannerImage}
        alt={"attorney landing page banner image"}
        title="ATTORNEYS"
      />
      <Container>
        <div className="center-wrapper">
          <NameBox>
            {attorneys.map((attorney, idx) => {
              return (
                <Link
                  href={`/attorneys/${
                    attorney.substring(0, 1) == "j"
                      ? attorney.split(", ")[0].split(" ").pop()
                      : attorney.split(" ").pop()
                  }`}
                  key={attorney + idx}
                >
                  <p className="attorney-name">{attorney.toUpperCase()}</p>
                </Link>
              );
            })}
          </NameBox>
          <span className="mobile-dropdown">
            <AttorneyDropDown title={"Attorneys"} />
          </span>
          <p className="body-copy">
            At Dally & Webb Family Law, PLLC, we are dedicated to providing you
            with an unparalleled level of legal representation for all your
            family law needs. Our team of experienced attorneys understands the
            complexities and sensitivities involved in family law matters, and
            we are here to guide you through every step of the process.
            <br />
            <br />
            Whether you are facing a divorce, child custody dispute, or any
            other family law issue, we are here to fight for your rights and
            ensure that your voice is heard. Our priority is always to protect
            your interests and those of your family.
          </p>
        </div>
        <WhyChooseUs />
      </Container>
    </>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  .center-wrapper {
    width: 100%;
    max-width: 1320px;
    margin: 0 auto;
    padding: 4rem;
    display: flex;
    justify-content: space-between;
  }

  .body-copy {
    max-width: 800px;
  }

  .mobile-dropdown {
    display: none;
  }

  @media (max-width: 1300px) {
    .center-wrapper {
      flex-direction: column;
      align-items: center;
      padding: 3rem 2rem 5rem;
    }
    .mobile-dropdown {
      width: 100%;
      max-width: 492px;
      height: 44px;
      box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.1);
      display: block;
      margin: 2rem auto;
    }
  }
`;

const NameBox = styled.div`
  width: 100%;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  border-top: 1px solid #67318d;
  padding-top: 1rem;
  letter-spacing: 2px;
  gap: 1rem;

  .attorney-name {
    color: #808080;
    font-size: 20px;
    font-weight: 500;
    :hover {
      color: #c293ff;
    }
  }

  @media (max-width: 1300px) {
    display: none;
  }
`;
